import {HttpParams} from '@angular/common/http';
import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output,} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {ActivatedRoute, Params} from '@angular/router';
import {FormlyFieldConfig, FormlyFormOptions} from '@ngx-formly/core';
import {
  ApiResponse,
  BreadcrumbDto,
  CatalogWithAncestors,
  ConfirmDialogComponent,
  CustomerGroup,
  DamCatalogPlain,
  DamElasticDTO,
  DamItemVersion,
  FileService,
  ListTable,
  NgxEasyTablePagination,
  Picture,
  ProductCustomer,
  Role,
  StoreService
} from 'compob2b-libs';
import {Config, DefaultConfig} from 'compob2b-table';
import {BehaviorSubject, Observable} from 'rxjs';
import {catchError, filter, map, pairwise, switchMap, take, takeUntil, tap} from 'rxjs/operators';
import {translations} from '../../../../../environments/translations.ru';
import {CrudConfig} from '../../../../admin-shared/interfaces/crud.config';
import {RelatedEntity} from '../../../../admin-shared/interfaces/related.entity';
import {FormConfigService} from '../../../../admin-shared/services/form-config.service';
import {DamShareComponent} from '../../dam-share/dam-share.component';
import {DamUnitItemsComponent} from '../../dam-unit-items/dam-unit-items.component';
import {DamService} from '../../dam.service';

interface DamItemVersionTypeCount {
  count: number;
  typeOfFile: string;
}

interface Selected {
  selected: boolean;
}

export interface DamItemVersionTypeCountWSelected extends DamItemVersionTypeCount, Selected {
}

@Component({
  selector: 'app-dam-catalog',
  templateUrl: './dam-catalog.component.html',
  styleUrls: ['./dam-catalog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DamCatalogComponent extends ListTable implements OnInit {
  @Input() pagination: NgxEasyTablePagination;
  @Input() productList$: Observable<DamElasticDTO[]>;
  productListSubject = new BehaviorSubject<DamElasticDTO[]>([]);
  @Input() showOnlySupplerWarehouse = false;
  @Input() catalogId: number;
  @Input() configURI: string;
  @Input() catalogBreadCrumbs: Observable<BreadcrumbDto[]>;
  // @Input() catalogBreadCrumbs: Observable<BreadcrumbCatalog[]>;
  @Input() fieldsFeatures: FormlyFieldConfig[];
  @Input() formFilter = new FormGroup({});
  @Input() options: FormlyFormOptions = {};
  @Input() modelFeatures: any = {};

  @Input() fieldsFeaturesFast: FormlyFieldConfig[];
  @Input() formFilterFast = new FormGroup({});
  @Input() optionsFast: FormlyFormOptions = {};
  @Input() modelFeaturesFast: any = {};

  @Output() catalogChosenEvent = new EventEmitter<CatalogWithAncestors>();
  @Output() removeCatalogEvent = new EventEmitter<CatalogWithAncestors>();

  isShowProductList = false;
  isShowProductTable = true;
  isShowProductTableMore = false;

  createFolderName: string = '';
  damElasticDTO: DamElasticDTO = null;
  conditionalBalance: boolean;
  public configuration: Config;
  supplier = translations.supplier;
  readonly customerGroup$ = this.storeService.getCustomerGroup();
  customerGroup: CustomerGroup;
  productShow = false;

  damItemVersionWithDocumentInfo: DamItemVersion[];
  damItemVersionWithDocumentInfoExtensions: string[];
  damItemVersionWithDocumentInfoExtensionsCount: DamItemVersionTypeCountWSelected[];

  public selected$ = new BehaviorSubject(new Set());

  formBatch = new FormGroup({});
  configBatch: CrudConfig;
  optionsBatch: FormlyFormOptions = {};
  modelBatch: any = {};
  allRoles: Role[];
  filters = [];
  selectedElements: DamElasticDTO[] = [];

  constructor(
    protected readonly activatedRoute: ActivatedRoute,
    private readonly fileService: FileService,
    private readonly storeService: StoreService,
    protected readonly damService: DamService,
    protected readonly formsConfig: FormConfigService
  ) {
    super();
  }

  ngOnInit(): void {
    this.subOnRouteChanges();

    let damView = localStorage.getItem('damView');
    if (damView === undefined) {
      damView = 'table';
    }
    this.showProductBlocks(damView);
    this.conditionalBalance = this.storeService.getConditionalBalance();
    this.configuration = {...DefaultConfig};
    // ... etc.
    this.columns = [
      {key: 'phone', title: 'Phone'},
      {key: 'age', title: 'Age'},
      {key: 'company', title: 'Company'},
      {key: 'name', title: 'Name'},
      {key: 'isActive', title: 'STATUS'},
    ];

    const allRoles = this.compoApiService.get<Role[]>('/dam-menu/list-roles-for-batch/')
      .pipe(map(response => response.data), tap(data => this.allRoles = data));

    const relatedEntities: RelatedEntity[] = [
      {multipleEntity: allRoles, multipleField: 'rolesName'}
    ];

    this.configBatch = {
      uri: '/dam/',
      columns: [
        {
          key: 'forAll',
          className: 'col-3',
          title: translations.forAll,
          placeholder: translations.forAll,
          searchEnabled: false,
          formly: true,
          grid: true,
          defaultValue: false,
          type: 'checkbox',
          required: true,
          templateOptions: {label: translations.forAll},
        },
        {
          key: 'operation',
          className: 'col-3',
          title: translations.operations,
          placeholder: translations.operations,
          formly: true,
          defaultValue: 'none',
          type: 'select',
          templateOptions: {
            label: translations.operations,
            options: [
              {label: translations.selectOperations, value: 'none'},
              {label: translations.makeEnabled, value: 'enable'},
              {label: translations.makeDisable, value: 'disable'},
              {label: translations.dam.toApproved, value: 'approved'},
              {label: translations.dam.notApproved, value: 'notApproved'},
              {label: translations.damChangeAcl, value: 'changeAcl'},
              {label: translations.changeCategory, value: 'category'},
            ],
          },
          width: '100%',
          grid: false
        },
        {
          key: 'deleteAction',
          className: 'col-3',
          title: translations.delete,
          placeholder: translations.delete,
          formly: true,
          type: 'checkbox',
          defaultValue: false,
          hideExpression: model => model.operation !== 'changeAcl',
          width: '100%',
          grid: false
        },
        {
          key: 'rolesName',
          className: 'col-3',
          title: translations.roles,
          placeholder: translations.roles,
          formly: true,
          type: 'select',
          templateOptions: {
            label: translations.roles,
            type: 'array',
            valueProp: 'name',
            labelProp: 'header'
          },
          expressionProperties: {
            'templateOptions.required': (model: any, formState: any, field: FormlyFieldConfig) => {
              return model.operation === 'changeAcl';
            },
          },
          hideExpression: model => model.operation !== 'changeAcl',
          width: '100%',
          grid: false
        },
        {
          key: 'changeAclMode',
          className: 'col-3',
          title: translations.changeModesLabel,
          placeholder: translations.changeModesLabel,
          formly: true,
          defaultValue: 1,
          type: 'multicheckbox',
          templateOptions: {
            label: translations.changeModesLabel,
            options: [
              {label: translations.dam.read, value: 1},
              {label: translations.dam.write, value: 2},
              {label: translations.dam.administration, value: 16},
              {label: translations.dam.create, value: 4},
              {label: translations.dam.delete, value: 8},
            ],
          },
          hideExpression: model => model.operation !== 'changeAcl',
          expressionProperties: {
            'templateOptions.required': (model: any, formState: any, field: FormlyFieldConfig) => {
              return model.operation === 'changeAcl';
            },
          },
          width: '100%',
          grid: false
        },
        {
          key: 'catalogId',
          title: translations.catalog,
          placeholder: translations.catalog,
          formly: true,
          type: 'dam-catalog-picker',
          expressionProperties: {
            'templateOptions.required': (model: any, formState: any, field: FormlyFieldConfig) => {
              return model.operation === 'category';
            },
          },
          hideExpression: model => model.operation !== 'category',
          width: '100%',
          grid: false
        },

      ],
      title: translations.operations,
      relatedEntity: relatedEntities,
      absolutePath: ''
    };
    this.formsConfig.setConfig(this.configBatch.columns).formly();

    relatedEntities.forEach(item => this.formsConfig.addMultipleOptions(item.multipleField, item.multipleEntity));

    this.formsConfig.setConfig(this.configBatch.columns).formly();
  }

  openModalProduct(product: ProductCustomer): void {
    // if (product !== undefined) {
    //   this.storeService.nextCurrentProduct(product.syncUid);
    //   this.dialogService.open(ModalProductComponent, {
    //     context: {
    //       productUid: product.syncUid
    //     }
    //   }).onClose.pipe(takeUntil(this.unsubscribe)).subscribe();
    // }
  }

  showProductBlocks(type: string) {
    if (type === 'list') {
      this.isShowProductList = true;
      this.isShowProductTable = false;
      this.isShowProductTableMore = false;
      this.productShow = false;
    } else if (type === 'table') {
      this.isShowProductList = false;
      this.isShowProductTable = true;
      this.isShowProductTableMore = false;
    } else if (type === 'more') {
      this.isShowProductList = false;
      this.isShowProductTable = false;
      this.isShowProductTableMore = true;
    }
    localStorage.setItem('damView', type);
  }

  getImageUri(picture: Picture, width: number = 96) {
    return picture === null ? null : this.fileService.getImageSrc(picture.name + '.' + picture.type, 96);
  }

  changeSort($event) {
    console.log($event);
    const sortData = $event.split('_');
    const queryParams: Params = {sort: sortData[0], direction: sortData[1]};
    this.router.navigate(
      ['.'],
      {
        relativeTo: this.activatedRoute,
        queryParams,
        queryParamsHandling: 'merge'
      });
  }

  shareDamItems() {
    this.windowService.open(DamShareComponent, {
      context: {
        damItems: this.selectedElements,
        damCatalog: null,
        shareType: 0
      }
    });
  }

  downloadDamItems() {
    this.fileService.downloadPostUrl('/dam-download/dam-items/', {
      damItemsIds: Array.from(this.selected$.value)
    })
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(response => {
        FileService.saveAs(response, 'download.zip');
      });
  }

  unitDamItems() {
    if (this.selectedElements.length > 1) {
      this.windowService.open(DamUnitItemsComponent, {
        title: 'Объединить элементы',
        context: {
          damItems: this.selectedElements
        }
      });
    }
  }

  enableDamItems() {

    this.dialogService.open(ConfirmDialogComponent, {
      context: {
        description: 'Активировать?'
      }
    }).onClose.pipe(
      filter(result => result === true),
      switchMap(_ => this.enableDam()),
      tap(_ => this.cdr.detectChanges()),
      takeUntil(this.unsubscribe),
    ).subscribe(_ => this.successToast(translations.successfullyCreate),
      error => {
        this.handleError(error);
      }
    );
  }

  approveDamItems() {

    this.dialogService.open(ConfirmDialogComponent, {
      context: {
        description: 'Одобрить?'
      }
    }).onClose.pipe(
      filter(result => result === true),
      switchMap(_ => this.approveDam()),
      tap(_ => this.cdr.detectChanges()),
      takeUntil(this.unsubscribe),
    ).subscribe(_ => {
        this.successToast(translations.successfullyCreate);
      }
      ,
      error => {
        this.handleError(error);
      }
    );

  }

  deleteDamItems() {

    this.dialogService.open(ConfirmDialogComponent, {
      context: {
        description: 'Удалить?'
      }
    }).onClose.pipe(
      filter(result => result === true),
      switchMap(_ => this.deleteDam()),
      tap(_ => this.cdr.detectChanges()),
      takeUntil(this.unsubscribe),
    ).subscribe(_ => {
        this.successToast(translations.successfullyCreate);
      }
      ,
      error => {
        this.handleError(error);
      }
    );
  }

  public approveDam(): Observable<any> {
    return this.compoApiService.post('/dam/items/set-approved', {
      damItemsIds: Array.from(this.selected$.value)
    })
      .pipe(takeUntil(this.unsubscribe));
  }

  public enableDam(): Observable<any> {
    return this.compoApiService.post('/dam/items/set-enabled', {
      damItemsIds: Array.from(this.selected$.value)
    })
      .pipe(takeUntil(this.unsubscribe));
  }

  public deleteDam(): Observable<any> {
    return this.compoApiService.post('/dam/items/set-deleted', {
      damItemsIds: Array.from(this.selected$.value)
    })
      .pipe(takeUntil(this.unsubscribe));
  }

  public batchSubmit() {
    if (this.formBatch.invalid) {
      return false;
    }

    if (this.selected.size === 0 && this.modelBatch.forAll === false) {
      this.warningToast(translations.batchUpdateError);
      return false;
    }

    if (this.modelBatch.operation === 'none') {
      this.warningToast(translations.selectOperations);
      return false;
    }

    const tagsSelected = {};
    const changeAclModeSelected = {};//changeAcl
    const featureEditMulti = [];
    if (this.modelBatch.operation === 'tags' && Object.keys(this.modelBatch.tags).length > 0) {
      Object.keys(this.modelBatch.tags).forEach(key => {
        const value = this.modelBatch.tags[key];
        if (value === true) {
          tagsSelected[key] = value;
        }
      });
    }
    if (this.modelBatch.operation === 'tags' && Object.keys(tagsSelected).length === 0) {
      this.errorToast(translations.selectTag);
      return false;
    }

    if (this.modelBatch.operation === 'changeAcl' && Object.keys(this.modelBatch.changeAclMode).length > 0) {
      Object.keys(this.modelBatch.changeAclMode).forEach(key => {
        const value = this.modelBatch.changeAclMode[key];
        if (value === true) {
          changeAclModeSelected[key] = value;
        }
      });
    }
    if (this.modelBatch.operation === 'tags' && Object.keys(changeAclModeSelected).length === 0) {
      this.errorToast(translations.selectChangeAclModeSelected);
      return false;
    }

    // if (this.modelBatch.operation === 'changeAcl') {
    //   for (const sourceFeatureId in this.modelBatch.templateMapping) {
    //     const featureMapping: TemplateFeatureDestMapping = this.modelBatch.templateMapping[sourceFeatureId];
    //     const itemFeatureMapping: TemplateFeatureMapping = {sourceFeatureId: parseInt(sourceFeatureId, 10), ...featureMapping};
    //     templateMapping.push(itemFeatureMapping);
    //   }
    // }

    const paramsForBatch = {
      operation: this.modelBatch.operation,
      forAll: this.modelBatch.forAll,
      catalogId: this.modelBatch.catalogId,
      catalogs: this.modelBatch.catalogs,
      changeMode: this.modelBatch.changeMode,
      changeAclMode: changeAclModeSelected,
      tags: tagsSelected,
      deleteAction: this.modelBatch.deleteAction,
      brandId: this.modelBatch.brandId,
      manufacturerId: this.modelBatch.manufacturerId,
      operationProductParams: this.modelBatch.operationProductParams,
      operationProductParamsInput: this.modelBatch.operationProductParamsInput,
      unitId: this.modelBatch.unitId,
      rolesName: this.modelBatch.rolesName,
      productGroupId: this.modelBatch.productGroupId,
      templateId: this.modelBatch.templateId,
      featuresId: this.modelBatch.featuresId,
      sourceValue: this.modelBatch.sourceValue,
      featureEditMulti,
      fieldConfigUpdate: this.modelBatch.fieldConfigUpdate,
      fieldConfigReplace: this.modelBatch.fieldConfigReplace === true,
      selected: Array.from(this.selected$.value),
      newTemplateId: this.modelBatch.newTemplateId,
    };

    const params: any = this.activatedRoute.snapshot.queryParams;
    const queryParamsString = new HttpParams({fromObject: params}).toString();
    const uri: string = '/dam/batch/' + this.catalogId + '?' + queryParamsString;

    this.dialogService.open(ConfirmDialogComponent, {
      context: {
        description: translations.batchCreate
      }
    }).onClose.pipe(
      filter(result => result === true),
      switchMap(_ => this.createBatch(uri, paramsForBatch)),
      tap(_ => this.cdr.detectChanges()),
      takeUntil(this.unsubscribe),
    ).subscribe(_ => {
        this.successToast(translations.successfullyCreate);
      }
      ,
      error => {
        this.handleError(error);
      }
    );
  }

  protected createBatch(uri, paramsForBatch) {
    return this.compoApiService.post(uri, paramsForBatch);
  }

  elementClickEventHandler(element: DamElasticDTO) {
    this.damElasticDTO = element;

    this.compoApiService.get<DamItemVersion[]>('/dam/' + element.id + '/versions').pipe(takeUntil(this.unsubscribe)).subscribe(response => {

      this.damItemVersionWithDocumentInfoExtensions = [];
      this.damItemVersionWithDocumentInfoExtensionsCount = [];
      this.damItemVersionWithDocumentInfo = response.data;

      this.damItemVersionWithDocumentInfo.forEach(damItemVersion => {
        this.damItemVersionWithDocumentInfoExtensions.push(damItemVersion.mimeType);
      });
      this.damItemVersionWithDocumentInfoExtensions = this.damItemVersionWithDocumentInfoExtensions.filter(this.onlyUnique);
      this.damItemVersionWithDocumentInfoExtensions.forEach(oneExtension => {
        const itms = this.damItemVersionWithDocumentInfo.filter(version => version.mimeType == oneExtension);
        let damItemCountType = {} as DamItemVersionTypeCountWSelected;
        damItemCountType.count = itms.length;
        damItemCountType.typeOfFile = oneExtension;
        this.damItemVersionWithDocumentInfoExtensionsCount.push(damItemCountType);
      });

      this.productShow = true;
      this.cdr.detectChanges();
    });
    // const sidebar = document.getElementById('dam-item-sidebar');
    // sidebar.classList.add('is-open');
  }

  onlyUnique(value, index, array) {
    return array.indexOf(value) === index;
  }

  closeSidebar() {
    this.productShow = false;
  }

  onElementSelect(selectedItem: DamElasticDTO) {
    if (selectedItem?.selected) {
      this.selectedElements.push(selectedItem);
    } else {
      this.selectedElements = this.selectedElements.filter(item => item?.id !== selectedItem?.id);
    }
    console.log('selected SET', this.selected$.value);
    console.log('selectedElements', this.selectedElements);
    this.cdr.detectChanges();
  }

  onAllElementSelect(selectedItemsArg: DamElasticDTO[]) {
    console.log('onAllElementSelect selectedItems before', this.selectedElements);
    const currentSelected = this.selectedElements;
    const newList: DamElasticDTO[] = this.uniqueByKey(currentSelected.concat(selectedItemsArg), 'id');

    this.selectedElements = newList.filter(item => item.selected);
    console.log('onAllElementSelect selectedItems after', this.selectedElements);
  }

  uniqueByKey(arr: any[], key: string): any[] {
    const map = new Map(arr.map(item => [item[key], item]));
    return Array.from(map.values());
  };

  onElementDownload(selectedItem: DamElasticDTO) {
    this.fileService.downloadUrl('/dam-download/dam-item/' + selectedItem?.id)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(response => {
        FileService.saveAs(response, selectedItem?.header + '.zip');
      });
  }

  onElementDelete(selectedItem: DamElasticDTO) {
    this.confirm(
      translations.confirmDelete + ' ' + translations.file.toLowerCase() + '?', new Observable(() => {
        this.compoApiService
          .delete<ApiResponse<string>>('/dam/item/' + selectedItem?.id)
          .pipe(take(1))
          .subscribe(
            _ => window.location.reload(),
            error => this.errorToast('У вас недостаточно прав для данной операции'));
      }));
  }

  onElementShare(selectedItem: DamElasticDTO) {
    let shareSet = new Set<number>;
    shareSet.add(selectedItem?.id);
    this.windowService.open(DamShareComponent, {
      context: {
        damItems: shareSet,
        damCatalog: null,
        shareType: 0
      }
    });

  }

  onElementChangeCatalog(selectedCatalog) {
    console.log(selectedCatalog.id);
  }

  getTotalFiltered(): number {
    let isFiltered = 0;
    if (this.fieldsFeatures != undefined) {
      this.fieldsFeatures.forEach(item => {
        if (item.templateOptions.isFiltered) {
          isFiltered++;
        }
      });
    }
    if (this.fieldsFeaturesFast != undefined) {
      this.fieldsFeaturesFast.forEach(item => {
        if (item.templateOptions.isFiltered) {
          isFiltered++;
        }
      });
    }
    return isFiltered;
  }

  createFastFolder() {
    this.compoApiService.post<any, DamCatalogPlain>('/dam-menu/create-folder-fast', {
      parentId: this.catalogId,
      header: this.createFolderName
    }).pipe(take(1), catchError(err => this.handleError(err))).subscribe(response => {
      window.location.href = '/cabinet/dam?catalog_id=' + response.data.id;
    });
  }

  isRootCatalog() {
    return this.catalogId < 1;
  }

  subOnRouteChanges() {
    this.activatedRoute.queryParams
      .pipe(
        pairwise()
      )
      .subscribe(([prevParams, currParams]) => {
        if (prevParams.catalog_id !== currParams.catalog_id) {
          this.selected$.value.clear();
          this.selectedElements = [];
        }
      });
  }
}
